import BaseUseCase from "../../base_use_case.js";

class UploadEditorImageUseCase extends BaseUseCase {

  execute(image) {
    let formData = new FormData();
    formData.append("editor_image[attachment]", image)
    
    return this.httpClient({
      ...this.requestConfig(),
      method: "post",
      url: `/api/v1/assets/editor_images`,
      data: formData,
    });
  }

  requestConfig() {
    let config = super.requestConfig();
    config.headers["Content-Type"] = "application/x-www-form-urlencoded";
    return config;
  }
}

const instance = new UploadEditorImageUseCase();
export default instance;